import { Toggle, Modal, Button, Loader } from "rsuite";
import { useState } from "react";
import { ApiSchemaInsuranceType } from "../models/api/insuranceType";
import { ApiInsuranceTypes } from "../core/apis/insuranceTypes";

export const InsuranceStatusToggle = ({
  insurance,
  handleStatusChange,
}: {
  insurance: ApiSchemaInsuranceType;
  handleStatusChange: (sKey: string, isDisabled: boolean) => void;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleToggle = async () => {
    setIsLoading(true);
    const res = await ApiInsuranceTypes.ToggleStatus(insurance);
    handleStatusChange(insurance.sKey, !!res.data.data?.isDisabled);
    setIsLoading(false);
    handleClose();
  };

  return (
    <>
      {isLoading ? (
        <Loader size="sm" />
      ) : (
        <Toggle
          size="sm"
          onChange={handleOpen}
          disabled={isLoading}
          checked={!insurance.isDisabled}
        />
      )}
      <Modal open={open} onClose={handleClose}>
        <Modal.Body>
          <p>
            Are you sure, you want to{" "}
            {insurance.isDisabled ? "enable" : "disable"}{" "}
            {insurance.displayName || insurance.name}?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            loading={isLoading}
            appearance="primary"
            onClick={handleToggle}
          >
            Ok
          </Button>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            appearance="subtle"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
